module.exports = __webpack_public_path__ + "static/media/PreferencesNextStepIcon.ec7cad17.svg";